<!--  -->
<template>
  <article class='add-register'>
    <group class="register-content">
      <x-input placeholder='必填，如王先生' :max="10" v-model="register.customer_name">
        <div slot="label" class="register-content__required weui_label"><span>客户姓名</span><em>*</em></div>
      </x-input>
      <input-number title='客户手机' placeholder='非必填，11位数字' :max="11" v-model="register.customer_mobile"></input-number>
      <x-input title='意向车型' placeholder="请输入" :max="10" v-model.trim="register.intention_car_model_name"></x-input>
      <interval-input title='购车预算' :maxLen="3" :valueL.sync='register.min_buy_car_budget' :valueR.sync='register.max_buy_car_budget'></interval-input>
      <selector title='意向等级' placeholder="请选择" :options="actionLevels" v-model="register.intention_level_id"></selector>
      <selector title='是否试驾' placeholder="请选择" :options="driveLists" v-model="register.is_test_drive"></selector>
      <selector title='来店类型' placeholder="请选择" :options="configTypes" v-model="register.arrival_type_id"></selector>
      <selector title='跟进结果' :options="resultList" v-model="register.follow_result"></selector>
    </group>
    <repeat-number-confirm v-model="confirmShow" :confirm='confirm'></repeat-number-confirm>
    <footer-btn title="保存" @submit="handleSubmit"></footer-btn>
  </article>
</template>

<script>
import {
  Selector,
  XInput,
  Group
} from '@lx-frontend/cvux'
import FooterBtn from '../components/FooterBtn'
import InputNumber from '../components/InputNumber'
import IntervalInput from '../components/IntervalInput'
import RepeatNumberConfirm from '../components/RepeatNumberConfirm'
import { mapActions, mapState } from 'vuex'
import { driveLists, resultList } from '../../common/professionalData'
import carRegisterMixins from '../mixins/carRegister.mixins'
import util from '../../common/util'

const initRegister = {
  customer_name: '',
  customer_mobile: '',
  intention_car_model_name: '',
  min_buy_car_budget: '',
  max_buy_car_budget: '',
  intention_level_id: '',
  is_arrival_notification: false,
  is_test_drive: false,
  arrival_type_id: '',
  follow_result: 1 // 新增客户默认为继续跟进
}

export default {
  components: {
    Selector,
    XInput,
    Group,
    FooterBtn,
    IntervalInput,
    InputNumber,
    RepeatNumberConfirm
  },
  mixins: [carRegisterMixins], // 包含了validatorForm formatParams
  mounted() {
    this.init()
  },
  data() {
    return {
      register: { ...initRegister },
      driveLists,
      resultList,
      isSubmit: false,
      confirmShow: false,
      confirm: {
        title: '号码已绑定',
        desc: '',
        fromCustomerId: '',
        toCustomerId: '',
        type: 'add'
      }
    }
  },
  computed: {
    ...mapState('salesReceptions', ['actionLevels', 'configTypes'])
  },
  methods: {
    ...mapActions('salesReceptions', ['fetchAllConfigs']),
    async init() {
      this.register = { ...initRegister }

      this.switchLoading({ status: true, text: '加载中...' })
      await this.fetchAllConfigs()
      this.switchLoading({ status: false, text: '' })
    },
    async handleSubmit() {
      if (this.isSubmit) return
      if (!this.validatorForm(this.register)) return

      const params = { ...this.register }
      this.formatParams(params, ['min_buy_car_budget', 'max_buy_car_budget'])

      this.isSubmit = true
      const res = await this.$rest.carRegister.addSalesCustomer(params)
      this.isSubmit = false

      const { code } = res
      if (![0, 1404].includes(code)) {
        this.$message.fail(res.message || '系统错误请稍后重试')
        return
      }
      if (code === 1404) {
        this.submitErrorCB(res)
        return
      }
      this.$message.success('新增客户成功', this.runBack)
    },
    submitErrorCB(res) {
      this.confirm = {
        title: '号码已绑定',
        desc: res.message,
        type: 'add',
        fromCustomerId: '',
        toCustomerId: res.data.customer_id
      }
      this.confirmShow = true
    }
  }
}
</script>
<style lang='less' scoped>
@w2: 75rem;
.add-register {
  .register-content {
    /deep/ .vux-no-group-title {
      margin-top: 0;
    }
    &__required {
      em {
        color: #e95552;
      }
    }
    .buy-car {
      // width: 108/@w2!important;
      /deep/ .weui_cell_bd {
        width: 108 / @w2!important;
        input {
          width: 108 / @w2;
        }
      }
      &__right {
        width: 396 / @w2;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .weui_cell {
          padding: 0;
        }
        .weui_cell:before {
          display: none;
        }
        .run-text {
          margin: 0 22px;
        }
        .money-text {
          margin-left: 22px;
        }
      }
    }
  }
}
</style>
